module.exports = "<selectize\n        config=\"{\n            plugins: ['remove_button'],\n            dropdownParent: 'body',\n            valueField: 'value',\n            labelField: 'name',\n            searchField: ['name'],\n            maxItems:to.multiple ? 50:1\n        }\" options='to.options' ng-model=\"model[options.key]\"></selectize>"


/*****************
 ** WEBPACK FOOTER
 ** ./components/formly/select.html
 ** module id = 43
 ** module chunks = 0
 **/